export default __webpack_public_path__ + "static/media/arrow-up-icon.6922b9ff.svg";